// Central SEO config + JSON-LD builders for rich results & AI search visibility.
export const SITE_URL = "https://abhijit.pro";
export const SITE_NAME = "Abhijit JK — Brand & Business Growth Consultant";
export const DEFAULT_OG_IMAGE = "/images/banner-home.jpg";

export const BRAND_KEYWORDS = [
    "brand consultant Bangalore", "business growth consultant Bangalore", "brand consultant Bengaluru",
    "brand strategy consultant India", "brand storyteller India", "visual designer Bangalore",
    "logo design consultant Bangalore", "branding consultant for MSME", "digital presence consultant",
    "website strategy consultant", "social media strategy consultant", "founder branding consultant",
    "brand identity consultant Bangalore", "branding expert Karnataka", "MSME consultant Karnataka",
    "business diagnostic report", "brand audit consultant", "website audit consultant",
    "business growth roadmap", "90 day business growth plan", "2 day business growth workshop",
    "Abhijit JK", "Ragi Media",
].join(", ");

export const PERSON_JSONLD = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Abhijit JK",
    jobTitle: "Brand & Business Growth Consultant",
    description: "Bengaluru-based brand consultant, brand storyteller, visual designer, and founder of Ragi Media.",
    worksFor: { "@type": "Organization", name: "Ragi Media" },
    url: SITE_URL,
    image: SITE_URL + "/images/about-hero.jpg",
    address: { "@type": "PostalAddress", addressLocality: "Bengaluru", addressRegion: "Karnataka", addressCountry: "IN" },
    sameAs: [
        "https://www.linkedin.com/in/abhijka/",
        "https://www.instagram.com/abhijit.jka/",
    ],
    knowsAbout: [
        "Brand Strategy", "Business Growth", "Brand Storytelling", "Visual Design",
        "Logo Design", "Website Strategy", "Social Media Strategy", "Digital Presence Audit",
        "UI/UX Design", "MSME Branding",
    ],
};

export const ORG_JSONLD = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    name: "Abhijit.pro",
    image: SITE_URL + DEFAULT_OG_IMAGE,
    "@id": SITE_URL,
    url: SITE_URL,
    telephone: "+91-99866-16397",
    priceRange: "₹1,999 - ₹50,000",
    address: { "@type": "PostalAddress", addressLocality: "Bengaluru", addressRegion: "Karnataka", addressCountry: "IN" },
    areaServed: ["Bengaluru", "Karnataka", "India"],
    founder: { "@type": "Person", name: "Abhijit JK" },
    sameAs: [
        "https://www.linkedin.com/in/abhijka/",
        "https://www.instagram.com/abhijit.jka/",
    ],
    hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Consulting Services",
        itemListElement: [
            { "@type": "Offer", price: "1999", priceCurrency: "INR", itemOffered: { "@type": "Service", name: "1-Hour Business Consultation" } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "Business Growth Workshops" } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "Website Review" } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "Social Media Strategy" } },
            { "@type": "Offer", itemOffered: { "@type": "Service", name: "Digital Presence Audit" } },
        ],
    },
};

export const breadcrumbJsonLd = (items) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: (items || []).map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: it.name,
        item: SITE_URL + it.path,
    })),
});

export const faqJsonLd = (items) => ({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: (items || []).map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
});

export const serviceJsonLd = ({ name, description, price, url }) => ({
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: name,
    name,
    description,
    provider: { "@type": "Person", name: "Abhijit JK" },
    areaServed: "IN",
    url: SITE_URL + url,
    offers: {
        "@type": "Offer",
        price: String(price),
        priceCurrency: "INR",
        url: SITE_URL + url,
        availability: "https://schema.org/InStock",
    },
});
